import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCartData, useLoading } from '../../hooks/order';
import loader from '../../images/loading-results.gif';
import { Carousel } from 'antd';
const contentStyle = {
  color: '#000',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const BackdropLoader = () => {
  const { t } = useTranslation();
  const { scheduleLoading } = useLoading();
  const { isInternetAdded, isWhiAdded } = useCartData();

  const fiberLoadingMessages = [
    t('loader.noCreditCheck'),
    t('loader.unlimitedData'),
    t('loader.customerSupport'),
    t('loader.noRateHikes'),
    t('loader.noBundles'),
  ];

  const whiLoadingMessages = [
    t('loader.noCreditCheck'),
    t('loader.customerSupport'),
    t('loader.noRateHikes'),
    t('loader.noBundles'),
  ];

  const loadingMessages = isWhiAdded ? whiLoadingMessages : fiberLoadingMessages;

  return (
    <>
      <div className="main-outer">
        <div className="outer-loader">
          <div className="loader-text"><img src={loader} alt="loading-animation" style={{ marginInline: 'auto' }} />
            <div className="carousel-outer">
              <Carousel autoplay effect="fade" autoplaySpeed={2000}>
                {loadingMessages.map((message) => (
                  <div key={message}>
                    <div style={contentStyle} className="responsive-font-set"><i className="fa-solid fa-circle-check"></i>{message}</div>
                  </div>
                ))}
                {scheduleLoading && isInternetAdded &&
                  <div>
                    <div style={contentStyle} className="responsive-font-set"><i className="fa-solid fa-circle-check"></i>{t('loader.checkingAppts')}</div>
                  </div>}
              </Carousel>
            </div>
          </div>
        </div >
      </div>
    </>
  )
};

export const Loader = () => {
  return (
    <div className="loader-out">
      <div className="loader">
        <div className="mian-loader">
          <span className="first"></span>
          <span className="second"></span>
          <span className="third"></span>
        </div>
      </div>
    </div>

  )
};



